import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import AddProduct from "./AddProduct";
import { Table } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCCJobOrderExporCurrencyList, getCCJobOrderExportHSNRITCCodesList, getProductListAccordingToInvoiceList } from '../../../../../../../Redux/action/CustomClearance/CCAction';
import { toast } from 'react-toastify';
import Beatloader from '../../../../../../../Common/Loaders/Beatloader';
import Swal from 'sweetalert2';
import axios from 'axios';
import { adminMainUrl } from '../../../../../../../Config';
import EditProduct from './EditProduct';
import { getCCJobOrderImportInvoiceList, getProductListAccordingToInvoiceListImport } from '../../../../../../../Redux/action/CustomClearance/CCImportAction';

const ProductTab = ({ token, user_id, b64id }) => {

  const navigate = useNavigate();
  const [invoice_id, setInvoice_id] = useState(0);
  const [product_id, setProduct_id] = useState(0);
  const dispatch = useDispatch();
  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => setAddShow(false);

  const handleAddShow = () => {
    if (invoice_id) {
      setAddShow(true);
    } else {
      toast.error("Please select an invoice.");
    }
  };

  const [editShow, setEditShow] = useState(false);
  const handleEditClose = () => setEditShow(false);
  const handleEditShow = (id) => {
    if (invoice_id) {
      setProduct_id(id);
      setEditShow(true);
    } else {
      toast.error("Please select an invoice.");
    }
  };


  useEffect(() => {
    if (token && user_id) {
      dispatch(getCCJobOrderExportHSNRITCCodesList(token, user_id));
      dispatch(getCCJobOrderExporCurrencyList(token, user_id));
      if (b64id) {
        let id = atob(b64id);
        if (id) {
          dispatch(getCCJobOrderImportInvoiceList(token, user_id, id));
        }
      }
    }
  }, [token, user_id, b64id]);

  useEffect(() => {
    if (token && user_id && b64id && invoice_id) {
      setProductList([]);
      let id = atob(b64id);
      if (id) {
        dispatch(getProductListAccordingToInvoiceListImport(token, user_id, id, invoice_id));
      }
    }
  }, [invoice_id])


  const refreshProduct = () => {
    if (token && user_id && b64id && invoice_id) {
      let id = atob(b64id);
      if (id) {
        dispatch(getProductListAccordingToInvoiceListImport(token, user_id, id, invoice_id));
      }
    }
  };

  const {
    loadingCCExpJobHSNRITCCodeList,
    CCExpJobHSNRITCCodeListData,
    CCExpJobHSNRITCCodeListDataError,

    loadingCCExpJobCurrencyList,
    CCExpJobCurrencyListData,
    CCExpJobCurrencyListDataError,

    loadingCCImpJobInvoiceList,
    CCImpJobInvoiceListData,
    CCImpJobInvoiceListDataError,

    loadingCCProductImpList,
    CCProductImpListData,
    CCProductImpListDataError,
  } = useSelector(state => state?.CCImportReducer);


  const [showLoader, setShowLoader] = useState(false);
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    if (loadingCCProductImpList) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }

    if (CCProductImpListData) {
      setProductList(CCProductImpListData);
    }
  }, [loadingCCProductImpList, CCProductImpListData])


  const [invoiceOptions, setInvoiceOptions] = useState([]);
  useEffect(() => {
    // console.log("CCImpJobInvoiceListData", CCImpJobInvoiceListData);
    if (CCImpJobInvoiceListData) {
      let arr = [];
      CCImpJobInvoiceListData.map(value => arr.push({ value: value.id, label: value.invoice_no }));
      setInvoiceOptions(arr);
    }
  }, [loadingCCImpJobInvoiceList, CCImpJobInvoiceListData]);

  const [RITCHSNOptions, setRITCHSNOptions] = useState([]);
  useEffect(() => {
    if (CCExpJobHSNRITCCodeListData) {
      let arr = [];
      CCExpJobHSNRITCCodeListData.map(value => arr.push({ value: value.id, label: value.ritc_no }));
      setRITCHSNOptions(arr);
    }
  }, [loadingCCExpJobHSNRITCCodeList, CCExpJobHSNRITCCodeListData,])

  const [currencyOptions, setCurrencyOptions] = useState([]);
  useEffect(() => {
    if (CCExpJobCurrencyListData) {
      let arr = [];
      CCExpJobCurrencyListData.map(val => arr.push({ value: val.id, label: `${val.currency} (${val.currency_symbol})` }));
      setCurrencyOptions(arr);
    }
  }, [loadingCCExpJobCurrencyList, CCExpJobCurrencyListData,])


  const handleDelete = (id) => {

    let config = {
      // method: "GET",
      headers: {
        'auth-token': token,
        'user_id': user_id,
        'Content-Type': 'application/json',
      }
    };
    if (!id) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "ID not provided!",
      });
      return;
    }
    if (!invoice_id) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Invoice not selected!",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(`${adminMainUrl}/api/customClearance/product/delete`,
          {
            id: id,
            custom_clearance_import_job_id: atob(b64id),
            custom_clearance_import_job_invoice_id: invoice_id
          },
          config
        ) // Replace with your API endpoint
          .then((response) => {
            // Success alert
            if (response.status == 200) {
              refreshProduct();
              Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: response.data.msg,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Error!",
                text: response.data.msg,
              });
            }

          })
          .catch((error) => {
            // Error alert
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong. Please try again.",
            });
          });
      }
    });
  };
  return (
    <>
      {
        invoiceOptions.length == 0 ?
          <div className="text-center my-2">
            Please add invoice before acessing products.
          </div>
          :
          showLoader ?
            <Beatloader />
            :
            <>
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-end mb-4">
                    <div
                      className="d-flex align-items-center me-2"
                    >
                      <Select
                        className="custom-selector"
                        placeholder="Select Invoice"
                        name="discharge_port_id"
                        options={invoiceOptions}
                        onChange={option => {
                          setInvoice_id(option.value);
                          // formik.setFieldValue('discharge_port_id', option.value);
                        }}
                        value={invoiceOptions.find(option => option.value == invoice_id) || null}
                        isLoading={loadingCCImpJobInvoiceList}
                      />
                    </div>
                    {invoice_id ?
                      <div
                        className="btn btn-primary cursor-pointer me-2"
                        onClick={handleAddShow}
                      >
                        <i className="ti ti-square-rounded-plus me-2" />
                        Add Product
                      </div> : null}
                  </div>

                  <div className="table-responsive custom-table">
                    <table className="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th scope="col">S.No.</th>
                          <th scope="col">Product Description</th>
                          <th scope="col">RITC_HSN_code</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">SQC Quantity</th>
                          <th scope="col">Unit</th>
                          <th scope="col">Per</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          productList.length > 0 ?
                            productList.map((val, index) => {
                              return <tr key={index + 1}>
                                <th scope="row">{index + 1}</th>
                                <td>{val.product_description}</td>
                                <td>{val.RITC_HSN_code}</td>
                                <td>{val.quantity} {val.quantity_currency_type}</td>
                                <td>{val.SQC_qty} </td>
                                <td>{val.unit_price} {val.unit_price_type}</td>
                                <td>{val.per} {val.per_type}</td>
                                <td>{val.amount} {val.amount_currency_type}</td>
                                <td><div className="dropdown table-action">
                                  <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right">
                                    <div className="dropdown-item cursor-pointer"
                                      onClick={() => handleEditShow(val?.id)}
                                    >
                                      <i className="fas fa-edit text-blue me-2"></i> Edit
                                    </div>
                                    <div className="dropdown-item cursor-pointer"
                                      onClick={() => handleDelete(val?.id)}
                                    >
                                      <i className="fa-solid fa-trash text-blue me-2"></i> Delete
                                    </div>
                                  </div>
                                </div>
                                </td>
                              </tr>
                            })
                            :
                            <tr>
                              <td colSpan={9}>No data found.</td>
                            </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <AddProduct
                token={token}
                user_id={user_id}
                b64id={b64id}
                addShow={addShow}
                invoice_id={invoice_id}
                handleAddClose={handleAddClose}

                loadingCCExpJobHSNRITCCodeList={loadingCCExpJobHSNRITCCodeList}
                RITCHSNOptions={RITCHSNOptions}
                loadingCCExpJobCurrencyList={loadingCCExpJobCurrencyList}
                currencyOptions={currencyOptions}

                refresh={refreshProduct}
              />

              <EditProduct
                token={token}
                user_id={user_id}
                b64id={b64id}
                addShow={editShow}
                invoice_id={invoice_id}
                product_id={product_id}
                handleAddClose={handleEditClose}

                loadingCCExpJobHSNRITCCodeList={loadingCCExpJobHSNRITCCodeList}
                RITCHSNOptions={RITCHSNOptions}
                loadingCCExpJobCurrencyList={loadingCCExpJobCurrencyList}
                currencyOptions={currencyOptions}

                refresh={refreshProduct}
              />
            </>
      }

    </>


  )
}

export default ProductTab